// removed by extract-text-webpack-plugin
module.exports = {"text800":"_3pomOxmrDd1OnFBu_zVn6W","text700":"_10jFKAs8NfyjI0uYImOS1o","text600":"_1xJdAj30gZDVLJ39PXcT7K","text500":"_3gFLTPSWVjqN4DgqCVR4YI","text400":"yApHdW9H0HJbOOmQFJPX4","text300":"_1jZ4zHZo0y5kTV08gpEhpL","text200":"_1o6oghwbB8zuHq4l5NjYzz","textParagraph":"_3gs9ip4YD4rKLKsxtJqEWj","crimp":"_21lWjRz-3UPEQMjz2tmrrK","trim":"_3Ozb4e-YhuHHd45S9Kr_1L","flexCenter":"JVXZ8MXZZ1WgpoFQ33QOr","hideTextOverflow":"_2XyIi8co0_JcCECU2PcaKW","marginPageMainContent":"_13g7nb5LD6Zp8C-n6OeRGk","kitchen":"_1LgE17qvxNX6ggLavDHQsf","section":"_2INOnILMZNrGWLndTe1cYk"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PageKitchen/styles.scss
// module id = 1327
// module chunks = 0